// src/styles/theme.ts

// src/styles/theme.ts
export const theme = {
  fonts: {
    body: "var(--FontBody)",
  },
  colors: {
    Black: "var(--Black)",
    White: "var(--White)",
    Green: "var(--Green)",
    LightGreen: "var(--LightGreen)",
    Yellow: "var(--Yellow)",
    Gray: "var(--Gray)",
    DarkGray: "var(--DarkGray)",

    // New shades for controls
    Dark: "var(--Dark)",
    DarkAlt: "var(--DarkAlt)",
    MidGray: "var(--MidGray)",
    LightGray: "var(--LightGray)",

    Bg: "var(--Bg)",
    BgAlt: "var(--BgAlt)",
    Text: "var(--Text)",
    TextMuted: "var(--TextMuted)",

    NavBubbleBg: "var(--NavBubbleBg)",
    NavBubbleBorder: "var(--NavBubbleBorder)",

    WindowTitlebarBg: "var(--WindowTitlebarBg)",
    WindowTitlebarText: "var(--WindowTitlebarText)",
    WindowControlBg: "var(--WindowControlBg)",
    WindowControlBorder: "var(--WindowControlBorder)",
    WindowControlText: "var(--WindowControlText)",
  },
};


export type Theme = typeof theme;
